module.exports = __webpack_public_path__ + "img/medium-risk-en.c63797b7.png";